import { Collapse } from '../../../libs/gin-tonic/components/collapse/index';
import { Component } from '../../../libs/gin-tonic/helpers/compiler';

@Component({ className: 'js-search' })
export class SearchComponent {
	private form: HTMLFormElement;
	private resultsList: HTMLElement;
	private collapse: Collapse;
	private collapseResults: Collapse;
	private collapseExtra?: Collapse;

	constructor(public element: HTMLElement) {
		this.collapse = Collapse.getInstance(this.element);
		this.form = element.querySelector('.js-search-form') as HTMLFormElement;
		this.resultsList = element.querySelector('.js-search-results-list') as HTMLElement;

		this.collapseResults = new Collapse(element.querySelector('.js-search-results') as HTMLElement, {
			closeSiblings: true
		});
		const collapseExtra = element.querySelector('.js-search-extra') as HTMLElement;
		if (collapseExtra) {
			this.collapseExtra = new Collapse(collapseExtra, {
				closeSiblings: true
			});
		}

		this.form.addEventListener('submit', e => {
			e.preventDefault();
			this.submit();
		});

		if (this.form.elements['term'].value) {
			this.submit();
		}
	}

	private submit() {
		const term = this.form.elements['term'].value;
		const page = this.form.elements['page'].value;
		this.collapse.show();
		if (term) {
			fetch(`${this.form.action}&term=${term}&page=${page}`, {
				method: this.form.method
			})
				.then(o => o.text())
				.then(result => {
					this.resultsList.innerHTML = result;
					this.collapseResults.show();
					const pagerBtns = this.resultsList.querySelectorAll('.js-page');
					if (pagerBtns)
						pagerBtns.forEach(btn => {
							btn.addEventListener('click', e => {
								e.preventDefault();
								this.form.elements['page'].value = btn.getAttribute('data-page');
								this.submit();
							});
						});
				});
		} else {
			if (this.collapseExtra) {
				this.collapseExtra.show();
			}
		}
	}
}
